// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__DGBAR","inputWrap":"styles_inputWrap___fZHi","input":"styles_input__2Fbcv"};